import Axios from "axios";
let baseURL = '/api/activity'
import tokenUtil from '@/utils/TokenUtil';
export default {
  get(url, obj) {
    return Axios.get(baseURL + url, { params: { ...obj }, headers: { 'Authorization': tokenUtil.getToken() } });
  },
  post(url, obj) {
    console.log(tokenUtil.getToken(), 213412)
    return Axios.post(baseURL + url, { ...obj }, { headers: { 'Authorization': tokenUtil.getToken() } });
  },
  put(url) {
    return Axios.put(baseURL + url);
  },
  delete(url) {
    return Axios.delete(baseURL + url);
  }
}
